<template>
  <div class="addfile">
    <div class="file-bot">
      <div class="file-header flex-between">
        <ul class="h-left">
          <li v-for="(item, index) in content" :key="index" @click="openDialog(item.type)">
            <div>
              <img :src="item.icon" alt="" />
            </div>
            <p>{{ item.name }}</p>
            <file-img v-if="item.size" @uploadInfo="uploadInfo" :filelength="fileupload.length" :filetype="item.filetype" :uploadtype="item.type" :size="size"></file-img>
          </li>
        </ul>
        <div class="h-rig"></div>
      </div>
      <ul class="file-list">
        <li v-for="(item, i) in fileupload" :key="i" class="flex-between">
          <div class="file-center">
            <img :src="typeImg[item.msgType]" alt="" />
            <span style="color: #333333">{{ item.fileName }}</span>
          </div>
          <div class="file-list-rig">
            <span class="editBtn" v-if="item.msgType == 'link' || item.msgType == 'miniprogram'" @click="updataFileContent(item, i)" type="text">编辑</span>
            <span class="deleteBtn" @click="delFileContent(i)">
              <van-icon name="cross" />
            </span>
          </div>
        </li>
      </ul>
    </div>

    <!-- 网页-->
    <net-page
      v-show="showPage"
      @uploadInfo="appendForm"
      :isEdit="isEdit"
      :index="current"
      :ruleForm="ruleForm"
      :showPage="showPage"
      @editFileUpload="editFileUpload"
      @cancelBack="cancelBack"
    >
    </net-page>
    <!--    小程序-->
    <mini-program
      v-show="showMini"
      @uploadInfo="miniProgram"
      :isEdit="isEdit"
      :index="current"
      :ruleForm="ruleForm"
      :showMini="showMini"
      @editFileUpload="editFileUpload"
      @cancelBack="cancelBack"
    >
    </mini-program>
  </div>
</template>
<script>
import fileImg from "@/views/wegroupsend/fileImg";
import netPage from "@/views/wegroupsend/netPage";
import miniProgram from "@/views/wegroupsend/miniProgram";
import image from "@/assets/images/imgtType.png";
import video from "@/assets/images/vedio.png";
import file from "@/assets/images/file.png";
import link from "@/assets/images/page.png";
import imageIcon from "@/assets/images/image_icon.png";
import videoIcon from "@/assets/images/video_icon.png";
import fileIcon from "@/assets/images/file_icon.png";
import wesiteIcon from "@/assets/images/wesite_icon.png";
import miniProgramIcon from "@/assets/images/wechat.png";
export default {
  components: { fileImg, netPage, miniProgram },
  props: ["produreList"],
  name: "addFile",
  data() {
    return {
      addForm: {
        linkUrl: "",
        content: "",
        orderNum: "",
        picUrl: "",
        title: "",
        appId: "",
        url: "",
        fileName: "",
        msgType: "",
      },
      showPage: false, //显示网页
      showMini: false, //显示小程序页面
      filetype: "image/jpg,image/jpeg,image/png",
      size: 10,
      Imgsize: 2,
      content: [
        {
          icon: image,
          name: "图片",
          filetype: "image/jpg,image/jpeg,image/png",
          size: 10,
          type: "image",
        },
        {
          icon: video,
          name: "视频",
          filetype: "video/mp4,video/m4v",
          size: 10,
          type: "video",
        },
        {
          icon: file,
          name: "文件",
          filetype: ".doc,.docx,.pdf,.xls,.xlsx,.txt,.ppt,.pptx,.rar,.html,.htm",
          size: 20,
          type: "file",
        },
        { icon: link, name: "网页", type: "link" },
        {
          icon: miniProgramIcon,
          name: "小程序",
          type: "miniprogram",
        },
      ],
      typeImg: {
        image: imageIcon,
        video: videoIcon,
        file: fileIcon,
        link: wesiteIcon,
        miniprogram: miniProgramIcon,
      },
      fileupload: [],
      addtype: "",
      isEdit: false,
      current: 0,
      ruleForm: null,
    };
  },
  watch: {
    produreList(val) {
      this.fileupload = [];
      for (let i of val) {
        this.fileupload.push(i);
      }
    },
  },
  methods: {
    openDialog(type) {
      if (type == "link" || type == "miniprogram") {
        this.addtype = type;
        if (type == "link") {
          this.showPage = true;
        } else if (type == "miniprogram") {
          this.showMini = true;
        }
        this.$emit("isFixedBottom", false);
        // this.dialogVisible = true;
        this.addForm = {
          linkUrl: "",
          content: "",
          orderNum: "",
          picUrl: "",
          title: "",
          appId: "",
          url: "",
          fileName: "",
          msgType: "",
        };
      }
    },
    //添加网页数据
    appendForm(obj) {
      this.fileupload.unshift(obj);
      this.showPage = false;
      this.$emit("isFixedBottom", true);
      this.$emit("listArr", this.fileupload);
    },

    //编辑
    updataFileContent(item, i) {
      this.isEdit = true;
      this.ruleForm = item;
      this.current = i;

      if (item.msgType === "link") {
        this.showPage = true;
      } else {
        this.showMini = true;
      }
      this.$emit("isFixedBottom", false);
    },

    //取消关闭弹框
    cancelBack() {
      this.showPage = false;
      this.showMini = false;
      this.$emit("isFixedBottom", true);
    },

    //编辑后更新数据
    editFileUpload(item, i) {
      this.fileupload.splice(i, 1, item);
      this.isEdit = false;
      this.showMini = false;
      this.showPage = false;
      this.$emit("isFixedBottom", true);
      this.$emit("listArr", this.fileupload);
    },

    //添加小程序
    miniProgram(obj) {
      this.fileupload.unshift(obj);
      this.showMini = false;
      this.$emit("isFixedBottom", true);
      this.$emit("listArr", this.fileupload);
    },

    //删除某项
    delFileContent(key) {
      this.fileupload.splice(key, 1);
      console.log(this.fileupload);
      this.$emit("listArr", this.fileupload);
    },

    uploadInfo(obj) {
      this.fileupload.unshift(obj);
      console.log(this.fileupload);
      this.$emit("listArr", this.fileupload);
    },
  },
};
</script>
<style scoped lang="less">
@import "css/addFile";
</style>
